<template>
  <div class="py-2 pb-6 w-full max-w-xs">
    <div class="tour-general-hold-tap">
      <h1
        class="title tooltip"
        data-tip="Default options for Hold/Tap actions, can be overridden for each key separately"
      >
        Hold/Tap defaults
      </h1>
      <HoldTapOptions
        v-model:timeout="kb.defaults.timeout"
        v-model:tap_hold_interval="kb.defaults.tap_hold_interval"
        v-model:config="kb.defaults.config"
      />
    </div>

    <div class="tour-general-firmware">
      <h1 class="title tooltip" data-tip="Internal firmware settings">
        Firmware settings
      </h1>
      <SettingsOption
        label="Polling timeout"
        tooltip="Timeout in milliseconds for polling other half of the keyboard when negotiating roles."
      >
        <div class="join w-min">
          <IntegerInput
            class="w-[9ch] input-sm join-item"
            :min="100"
            :max="65535"
            v-model="kb.config.timeout"
          />
          <span class="join-item btn-input-unit btn-input-unit-sm">ms</span>
        </div>
      </SettingsOption>
    </div>
  </div>
</template>

<script setup lang="ts">
import { useKeyboardStore } from "@/stores";
import SettingsOption from "@/components/utils/SettingsOption.vue";
import IntegerInput from "@/components/utils/IntegerInput.vue";
import HoldTapOptions from "@/components/actions/HoldTapOptions.vue";

const kb = useKeyboardStore();
</script>

<style scoped>
.title {
  @apply block text-lg text-center mt-5 mb-1 py-1;
}
</style>
